export default (environment) => {
    const library = {}

    library.addTokenPrefix = (token) => {
        return `Bearer ${token}`
    }

    library.addApiSuffix = (url) => {
        return `${url}/api`
    }

    library.isOnLocalhost = () => {
        return environment === 'development'
    }

    library.addApiPrefix = (serverURL) => {
        const START = 1
        const DELETE_COUNT = 0
        const SEPARATOR = '.'
        const array = serverURL.split(SEPARATOR)
        array.splice(START, DELETE_COUNT, 'api')
        return array.join(SEPARATOR)
    }

    return library
}
